const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const IpWhiteListQuery: any = {
    GetIpWhiteListAll: `${Backofficebff}/v1/studioipwhitelist/get`,
    GetIpWhiteListById: `${Backofficebff}/v1/studioipwhitelist/get`,
};

